export const menu = {
  root: ({ props, attrs }: Record<string, any>) => ({
    class: [
      'min-w-[12rem]',
      'w-fit',
      {
        'rounded shadow-sm border border-solid border-grey-100 p-1 z-dialog mt-0.5': props.popup,
        'text-white bg-primary-800': attrs.theme === 'primary',
        'text-primary-900': attrs.theme !== 'primary',
        'bg-grey-100': attrs.theme === 'secondary',
        'bg-white': !['primary', 'secondary'].includes(attrs.theme),
      },
    ],
  }),
  list: {
    class: ['list-none', 'm-0', 'py-1', 'outline-none'],
  },
  item: ({ parent }: Record<string, any>) => ({
    class: [
      'cursor-pointer',
      'relative',
      'px-2',
      'py-1',
      'text-sm',
      {
        'text-white': parent.attrs.theme === 'primary',
        'text-primary-900': parent.attrs.theme !== 'primary',
      },
    ],
  }),
  itemContent: ({ context, parent }: Record<string, any>) => ({
    class: [
      'rounded',
      'transition-shadow',
      'duration-200',
      {
        'text-white hover:bg-white/25': parent.attrs.theme === 'primary',
        'text-primary-900': parent.attrs.theme !== 'primary',
        'hover:bg-grey-200': parent.attrs.theme === 'secondary',
        'hover:bg-grey-100': !['primary', 'secondary'].includes(parent.attrs.theme),
        'bg-primary-600': context.focused && parent.attrs.theme === 'primary',
        'bg-grey-200': context.focused && parent.attrs.theme === 'secondary',
        'bg-grey-100': context.focused && !['primary', 'secondary'].includes(parent.attrs.theme),
      },
    ],
  }),
  itemLink: ({ parent, props }: Record<string, any>) => ({
    class: [
      'flex',
      'items-center',
      'p-2',
      'no-underline',
      'overflow-hidden',
      'select-none',
      "after:content-['']",
      'after:absolute',
      'after:inset-0',
      {
        'text-white': parent.attrs.theme === 'primary' && !props.item.disabled,
        'text-primary-900': parent.attrs.theme !== 'primary' && !props.item.disabled,
        'cursor-not-allowed text-grey-400': props.item.disabled,
        'cursor-pointer': !props.item.disabled,
      },
    ],
  }),
  itemLabel: ({ context }: Record<string, any>) => ({
    class: [
      'flex items-center gap-2 text-sm',
      {
        '3xl:grow 3xl:after:ml-auto after:content-[attr(data-badge)] after:px-1.5 after:py-1 after:rounded-md after:text-2xs after:leading-tight after:font-bold after:whitespace-nowrap after:bg-white/20':
          context.item.badge,
      },
    ],
    'data-badge': context.item.badge,
  }),
  submenuLabel: ({ parent }: Record<string, any>) => ({
    class: [
      'font-bold',
      'm-0',
      'not-first:mt-6',
      'mb-1',
      'px-4',
      'rounded-tl-none',
      'rounded-tr-none',
      'text-2xs',
      'uppercase',
      {
        'text-white/50': parent.props.theme === 'primary',
        'text-primary-900': parent.props.theme !== 'primary',
      },
    ],
  }),
  transition: {
    enterFromClass: 'opacity-0 scale-y-[0.8]',
    enterActiveClass:
      'transition-[transform,opacity] duration-[120ms] ease-[cubic-bezier(0,0,0.2,1)]',
    leaveActiveClass: 'transition-opacity duration-100 ease-linear',
    leaveToClass: 'opacity-0',
  },
};
